import { Subject, from, BehaviorSubject } from 'rxjs';
import { activeCustomerId$ } from '@/services/activeCustomer$';
import { startWith, switchMap, publishReplay, refCount } from "rxjs/operators";
import { getDeviceManagerEquipments } from './getDeviceManagerEquipments';

const invalidate$ = new Subject();
export function invalidateCustomerDeviceManagerEquipments$() {
  invalidate$.next(null);
}

export const customerDeviceManagerEquipments$ = invalidate$.pipe(
  startWith(null),
  switchMap(() => activeCustomerId$.pipe(
      switchMap(customerId => {
            return customerId
            ? from(getDeviceManagerEquipments({CustomerId: customerId}))
            : new BehaviorSubject([])
      })
  )),
  publishReplay(1),
  refCount()
)
